import React from 'react';
import PropTypes from 'prop-types';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
import { SUMMARY_CARD } from '../SummaryCard';
export default function ChartSummaryCard(_ref) {
  var children = _ref.children,
      right = _ref.right;
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "jmtp-chart-summary-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "jmtp-chart-summary-left"
    }, children), /*#__PURE__*/React.createElement("div", {
      className: "jmtp-chart-summary-right"
    }, right));
  });
}
ChartSummaryCard[SUMMARY_CARD] = {
  cardClassName: function cardClassName() {
    return 'jmtp-chart-summary-card';
  },
  summaryClassName: function summaryClassName() {
    return 'jmtp-chart-summary';
  }
};
ChartSummaryCard.propTypes = {
  children: PropTypes.node,
  right: PropTypes.node
};
ChartSummaryCard.defaultProps = {
  children: null,
  right: null
};